<template>
  <div>
    <div class="search-box min">
      <div class="form">
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input class="value" v-model="searchObj.productName" placeholder="请输入" clearable />
        </div>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="search">查询</Button>
        <Button type="warning" @click="$refs.addRef.open()">新增</Button>
      </div>
    </div>

    <span class="tips-text" v-if="tabsListOne.length">提示：拖动列表项可改变顺序。</span>

    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="table-box">
      <Table :columns="columns" :data="tableData" @on-drag-drop="blurSort" draggable>
        <template slot-scope="{ row }" slot="sellTypeSlot">
          <div class="sellTypeColumn" v-if="row.sellType">
            <Tag color="blue" v-if="row.sellType.includes('1')">网销</Tag>
            <Tag color="blue" v-if="row.sellType.includes('2')">电销</Tag>
            <Tag color="blue" v-if="row.sellType.includes('3')">经代</Tag>
          </div>
          <div v-else>-</div>
        </template>
        <template slot-scope="{ row }" slot="simpleName">
          <Input v-model="row.simpleName" @on-blur="saveSimpleName(row)" @on-enter="saveSimpleName(row)" maxlength="30"/>
        </template>
        <template slot-scope="{ row }" slot="action">
          <a @click="remove(row)">移除</a>
        </template>
      </Table>
    </div>

    <!-- 新增 -->
    <add-search-config ref="addRef" :getProductList="queryTabOneList" :userInfo="userInfo"></add-search-config>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import filter from '@/api/filter';
import addSearchConfig from './components/addSearchConfig';
export default {
  name: 'hotProductConfig',
  components: {
    draggable,
    addSearchConfig
  },
  filter,
  data() {
    return {
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      total: 0,
      searchObj: {
        pageNo: 1,
        pageSize: 10
      },
      tabsListOne: [],
      tableData: [],
      orgList: [],
      ids: [],
      columns: [
        {
          title: '产品名称',
          align: 'center',
          minWidth: 300,
          tooltip: true,
          key: 'productName',
          render(h, params) {
            let text = params.row.productName;
            return h(
              'Tooltip',
              {
                class: 'flex-center',
                props: { placement: 'bottom-start', transfer: true }
              },
              [
                h(
                  'span',
                  {
                    class: 'txt-ellipsis2'
                  },
                  text
                ),
                h('span', { slot: 'content' }, text)
              ]
            );
          }
        },
        {
          title: '产品简称',
          align: 'center',
          minWidth: 200,
          slot: 'simpleName'
        },
        {
          title: '产品编码',
          align: 'center',
          minWidth: 120,
          key: 'productCode'
        },
        {
          title: '销售类型',
          align: 'center',
          minWidth: 120,
          slot: 'sellTypeSlot'
        },
        {
          title: '保险公司',
          minWidth: 140,
          align: 'center',
          key: 'companyName'
        },
        {
          title: '业务分类',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            const themeName = params.row.themeName;
            return <span>{themeName ? themeName : '-'}</span>;
          }
        },
        {
          title: '供应商',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            const source = params.row.source;
            return <span>{source ? source : '-'}</span>;
          }
        },
        {
          title: '状态',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const publishStatus = params.row.publishStatus;
            return <span>{publishStatus == '1' ? '已下架' : '已上架'}</span>;
          }
        },
        {
          title: '操作',
          minWidth: 80,
          align: 'center',
          slot: 'action',
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    this.queryOrgList();
  },
  methods: {
    // 保存简称
    saveSimpleName(item) {
      this.$http({
        url: '/buz/popularProductConfig/editSimpleName',
        type: 'POST',
        data: {
          simpleName: item.simpleName,
          id: item.id
        },
      }).then(res => {
        this.getProductList();
      });
    },
    // 处理请求参数
    setRequestParam() {
      let obj = JSON.parse(JSON.stringify(this.searchObj));
      if (obj.orgId.length) {
        obj.orgId = obj.orgId;
      } else {
        obj.orgId = '';
      }
      let { ...params } = obj;
      return params;
    },

    // 机构查询
    queryOrgList() {
      this.$http({
        url: '/buz/organizationBase/read/sub',
        data: {},
        type: 'POST'
      }).then(res => {
        this.orgList = res.data;
        this.searchObj = {
          ...this.searchObj,
          orgId: res.data && res.data[0].id
        };
        this.queryTabOneList();
      });
    },

    // 查询一级tab分类
    queryTabOneList() {
      this.$http({
        url: `/buz/hotProductTheme/array/first?orgId=${this.userInfo.levelCode != '10002' ? this.searchObj.orgId : this.userInfo.organId}`,
        type: 'GET'
      }).then(res => {
        this.tabsListOne = res.data;
        this.getProductList();
      });
    },

    // 查询产品列表
    getProductList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: '/buz/popularProductConfig/read/page',
        data: this.setRequestParam(),
        type: 'POST',
        apiPermissionCode: 'operate_3_0'
      }).then(res => {
        this.total = res.total;
        this.tableData = res.data;
        this.ids = this.tableData.map(v => v.id);
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 查询
    search() {
      this.searchObj.pageNo = 1;
      this.queryTabOneList(true);
    },

    // 排序
    blurSort(index1, index2) {
      this.ids.splice(index2, 0, this.ids.splice(index1, 1)[0]);
      this.$http({
        url: '/buz/popularProductConfig/rank',
        type: 'POST',
        data: {
          ids: this.ids
        }
      }).then(res => {
        this.$notice.success('修改成功');
        this.getProductList();
      });
    },

    // 移除
    remove(item) {
      this.$notice.inquiry('确认删除操作？').then(async () => {
        this.$http({
          url: `/buz/popularProductConfig/del?productCode=${item.productCode}&orgId=${this.searchObj.orgId ? this.searchObj.orgId : ''}`,
          type: 'GET',
          apiPermissionCode: 'operate_3_4'
        }).then(res => {
          this.$Message.success('移除成功');
          this.getProductList();
        });
      });
    },

    // 分页
    pageChange(pageNo) {
      this.searchObj.pageNo = pageNo;
      this.getProductList();
    }
  }
};
</script>

<style lang="scss" scoped>
.tips-text {
  display: block;
  font-size: 12px;
  margin: 12px 0;
}
.tabs-one {
  width: 100%;
  border-bottom: 1px solid #ececec;
  display: flex;
  margin-bottom: 20px;
  .tools-list {
    display: flex;
  }
  .tab-pane {
    position: relative;
    margin-right: 40px;
    height: 30px;
    a {
      font-size: 14px;
      color: #515c6f;
    }
  }
  & .tab-active {
    border-bottom: 2px solid #236dff;
    a {
      color: #236dff;
    }
  }
  .right {
    position: absolute;
    top: -5px;
    right: 0;
    .import-btn {
      margin-right: 10px;
      width: 80px;
      height: 30px;
      border: none;
      background-color: #f59045;
      color: #fff;
      border-radius: 2px;
    }
    .export-btn {
      width: 80px;
      height: 30px;
      color: #fff;
      border: none;
      border-radius: 2px;
      background-color: #55bc41;
    }
  }
}

.tabs {
  display: flex;
  margin-top: 10px;
  margin-bottom: 15px;
  .tools-list {
    display: flex;
  }
  .tab-pane {
    position: relative;
    padding: 4px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-right: 10px;
    background-color: #f7f8fa;
    font-size: 12px;
    a {
      color: #727c8e;
    }
  }
  & .active-tab {
    background-color: #236dff;
    a {
      color: #ffffff;
    }
  }
}

.pageBox {
  margin-top: 20px;
}
.action {
  width: 70px;
  display: flex;
  justify-content: space-between;
}
.table-box {
  /deep/ input {
    text-align: center;
  }
}
</style>